/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, observable, makeObservable } from 'mobx';
import { Microsoft365ObjectType } from '@veeam-vspc/models/web-controllers';

export class ProtectedMicrosoft365ObjectsStore {

    @observable microsoft365ObjectType: Microsoft365ObjectType;

    constructor(type: Microsoft365ObjectType, readonly lsStateId: string) {
        makeObservable(this);
        this.microsoft365ObjectType = type;
    }

    @action.bound
    setMicrosoft365ObjectType(v: Microsoft365ObjectType): void {
        this.microsoft365ObjectType = v;
    }
}
